<script lang="ts">
  import TaggingGroupIconObject from '$icons/TaggingGroupObjectIcon.svelte';
  import TaggingGroupIconTalent from '$icons/TaggingGroupTalentIcon.svelte';
  import type { FPost } from 'garden-common';
  import TaggingGroupItem from './TaggingGroupItem.svelte';
  import { fade } from 'svelte/transition';

  export let groupType: 'objects' | 'talents' = 'objects';
  export let taggings: FPost<string>['tags'] = [];
</script>

<div class="w-full h-full pt-5" in:fade={{ duration: 200 }}>
  <div class="flex pl-3 items-center">
    <div>
      {#if groupType === 'objects'}
        <TaggingGroupIconObject />
      {:else}
        <TaggingGroupIconTalent />
      {/if}
    </div>

    <div class="ml-[8px] uppercase font-bold">
      {(groupType === 'objects' && 'object') || 'talent'}
    </div>

    <div class="ml-[12px] text-sm font-medium bg-blueish-grey-100 p-[2px] rounded-[5px] px-2">
      {taggings.length}
    </div>
  </div>

  <div class="mt-[19px]">
    {#each taggings as tagging}
      <TaggingGroupItem {tagging} />
    {/each}
  </div>
</div>
